/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useMemo, useEffect } from "react";
import "../Styles/Donations.css";
import { useConfig } from "../../context/ConfigContext";

export default function DonationsTab() {
  const { config } = useConfig();
  const getUrl = config.REACT_APP_API_URL;
  const updateUrl = config.REACT_APP_API_URL2;
  const apiKey = config.REACT_APP_API_KEY;

  const [current, setCurrent] = useState(null);
  const [newTotal, setNewTotal] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const headers = useMemo(() => ({ "Api-Key": apiKey, "Content-Type": "application/json" }), [apiKey]);

  const refresh = async () => {
    setMsg("");
    setLoading(true);
    try {
      const res = await fetch(getUrl, {headers: headers, credentials: "include"});
      const data = await res.json();
      setCurrent(Number(data.donated.amountDonated) || 0);
    } catch (e) {
      setMsg("Failed to load current total.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []); // initial load

  const updateTotal = async () => {
    setLoading(true);
    setMsg("");
    try {
      const body = JSON.stringify({ amountDonated: Number(newTotal) || 0 });
      const res = await fetch(updateUrl, { method: "POST", headers, body, credentials: "include" });
      if (!res.ok) throw new Error("Bad response");
      await refresh();
      setNewTotal("");
      setMsg("Donation total updated.");
    } catch (e) {
      setMsg("Failed to update donation total.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-grid">
      <section className="card">
        <h2>💰 Manage Donation Totals</h2>
        <div className="don-row">
          <div className="stat">
            <span>Current Total</span>
            <strong>{current !== null ? `£${current.toLocaleString()}` : "—"}</strong>
          </div>
          <button className="btn ghost" onClick={refresh} disabled={loading}>Refresh</button>
        </div>

        <div className="form-row">
          <label>
            <span>New Total (£)</span>
            <input className="input-don" value={newTotal} onChange={(e) => setNewTotal(e.target.value)} placeholder="e.g. 12000" />
          </label>
          <button className="btn primary" onClick={updateTotal} disabled={loading || newTotal === ""}>Update Total</button>
        </div>
        {msg && <p className="muted" role="status">{msg}</p>}
      </section>
    </div>
  );
}